import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/Solutions.css';

const workflows = [
  ['Reception and call routing', 'Shape a voice workflow around common questions and the routes your team already uses.'],
  ['Lead qualification', 'Collect agreed details and identify the next step in a prospective customer conversation.'],
  ['Appointment reminders and follow-ups', 'Assess reminder and follow-up workflows against your calendar, messaging, and consent requirements.'],
  ['Customer support', 'Explore voice assistance for defined support questions, escalation paths, and handoff to your team.'],
  ['CRM and business-system connections', 'Plan integrations around the APIs, data access, and security requirements of your existing systems.'],
  ['Industry-specific workflows', 'Adapt conversation steps and call outcomes to your operating processes and industry context.'],
];

const AIVoiceSolution = () => (
  <main className="solution-detail">
    <SEO
      title="AI Voice Automation for Business | Bularis Tech"
      description="Discuss tailored AI voice workflows for reception, lead qualification, customer support, follow-ups, and telephony integrations with Bularis Tech."
      path="/solutions/ai-voice-automation"
    />
    <header className="solution-hero">
      <span className="solutions-eyebrow">Custom business solution</span>
      <h1>AI Voice Automation Tailored to Your Business</h1>
      <p>Every business handles customer conversations differently. Bularis Tech can assess and customize voice automation workflows around your processes, telephony environment, and operational requirements.</p>
    </header>

    <div className="solution-content">
      <section className="solution-section">
        <h2>A developed foundation, adapted to your workflow</h2>
        <p>AI Voice Engine is a Bularis Tech engineering project that brings together conversational AI, speech recognition and synthesis, call workflow management, and local lead capture. Its existing voice flows have been exercised in local test-call workflows.</p>
        <p>This project is a foundation for further work, not a claim that every business use case is a ready-to-deploy product. We first review your call flow, systems, data requirements, and operating environment, then define what can be built and validated.</p>
        <p>Read about the <Link to="/portfolio/ai-voice-engine">AI Voice Engine project and implemented capabilities</Link>, or explore our <Link to="/services">AI and business automation services</Link>.</p>
      </section>

      <section className="solution-section">
        <h2>Workflows to explore</h2>
        <p>Depending on feasibility, system access, and implementation scope, a tailored solution could support workflows such as:</p>
        <div className="voice-workflows">
          {workflows.map(([title, description]) => <article className="solution-step" key={title}><h3>{title}</h3><p>{description}</p></article>)}
        </div>
      </section>

      <section className="solution-section">
        <h2>What needs technical validation</h2>
        <ul className="solution-list">
          <li>Telephony provider, number provisioning, call routing, and local regulatory requirements</li>
          <li>CRM, calendar, support, or other third-party APIs and the access they permit</li>
          <li>Conversation design, escalation to a person, privacy, and data-retention expectations</li>
          <li>Call volumes, language needs, operating hours, and deployment environment</li>
        </ul>
        <p>External outbound dialing, appointment scheduling, CRM connections, and production deployment are not existing capabilities of the current engineering project; these require separate design, implementation, and validation.</p>
      </section>

      <section className="solution-cta">
        <div>
          <h2>Have a voice workflow in mind?</h2>
          <p>Request a demonstration discussion or tell us about the calls, systems, and outcomes you want to support.</p>
        </div>
        <Link to="/contact">Discuss an AI voice project</Link>
      </section>
    </div>
  </main>
);

export default AIVoiceSolution;
